/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { BlogConfigFragment, PageHeroesFragment } from "@cosmos/hygraph-schema";

import { HeroAlpha, HeroGlow, HeroArticleImage, HeroBravo } from ".";

export const getHero = (
	hero?: PageHeroesFragment | null,
	blogConfig?: BlogConfigFragment | null,
): React.JSX.Element | null => {
	if (!hero) return null;

	switch (hero.__typename) {
		case "CosmosHeroAlpha": {
			return <HeroAlpha {...hero} />;
		}
		case "CosmosHeroGlow": {
			return <HeroGlow {...hero} />;
		}
		case "CosmosHeroArticleImage": {
			return <HeroArticleImage {...hero} blogConfig={blogConfig} />;
		}
		case "CosmosHeroBravo": {
			return <HeroBravo {...hero} />;
		}
		default:
			return null;
	}
};
